import { render } from "./waitingPayment.vue?vue&type=template&id=45a76b8e"
import script from "./waitingPayment.vue?vue&type=script&lang=js"
export * from "./waitingPayment.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\f0719_o33zc9b\\Documents\\amer\\jeeran-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__